/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "50c6ecbb2337aa420a821cbfd4b66d91aa1d7a86";
